import React from 'react';
import PropTypes from 'prop-types';

import { Step as MuiStep } from '@material-ui/core';

const MultiStep = ({ children, ...rest }) => {
  return (
    <MuiStep
      {...rest}
    >
      { children }
    </MuiStep>
  )
}

MultiStep.defaultProps = {
  children: null,
}

MultiStep.propTypes = {
  children: PropTypes.node,
}

export default MultiStep;



// WEBPACK FOOTER //
// ./src/components/base/MultiStep/MultiStep.js